import type { ReactNode } from 'react';
import PolicySystemBanner from './PolicySystemBanner';

type PolicySystemAppShellProps = {
  children: ReactNode;
};

/** Authenticated app chrome: global policy-system status banner above page content. */
export default function PolicySystemAppShell({ children }: PolicySystemAppShellProps) {
  return (
    <div className="flex flex-col min-h-screen w-full">
      <PolicySystemBanner />
      <div className="flex flex-col flex-1 min-h-0 w-full">{children}</div>
    </div>
  );
}
